import React, {useState, useEffect} from 'react';
import {t} from 'react-switch-lang';
import DownloadBtn from './reportForm/components/downloadBtn/DownloadBtn';
import {useUserContext} from '../../contexts/UserContext';
import * as yup from 'yup';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import {format} from 'date-fns';
import './Report.scss';
import InputYear from '../../components/FormFields/inputDate/InputYear';

const KriReport2 = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const schema = yup.object().shape({
    year: yup.object().nullable().required(t('message.fieldRequired'))
  });

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {watch} = methods;

  let validFrom = watch('year');


  const user = useUserContext();

  let userRiskSector = false;
  let responsibleUser = false;
  let userInCharge = false;

  user.authorities.forEach((item) => {
    if (item === 'ROLE_RISK_SECTOR') {
      userRiskSector = true;
    }
    if (item === 'ROLE_RESPONSIBLE_USER') {
      responsibleUser = true;
    }
    if (item === 'ROLE_USER_IN_CHARGE') {
      userInCharge = true;
    }
  });

  useEffect(() => {
    setIsSubmitted(false);
  }, []);

  return (
    <div className="reports-page content">
      <FormProvider {...methods}>
        <div className="report-form-container" key={window.location.pathname}>
          <div className="row  ml-0 mr-0">
          <div className="form-group pr-5">
              <label className="label" htmlFor="year">
                {t('reports.year')}
              </label>
              <InputYear
                name="year"
                placeholderText={t('reports.yearPlaceholder')}
              />
              {
                validFrom === null && isSubmitted === true
              ? <span className="error-message position-absolute">{t('message.fieldRequired')}</span>
                : ''
              }
            </div>
            <DownloadBtn
              api={'key-indicators/key-indicator-movement-report'}
              paramsLength={1}
              setIsSubmitted={(e) => setIsSubmitted(e)}
              apiParameters={{
                year:
                validFrom !== null && validFrom !== undefined
                  ? `year=${encodeURIComponent(
                      format(validFrom, 'yyyy')
                    )}`
                  : ''
              }}
            />
          </div>
        </div>
      </FormProvider>
    </div>
  );
};

export default KriReport2;
